<template>
    <div id="common-nav">
        <div class="logo">
            <img src="../../assets/img/userMethods/logo.png" alt="">
        </div>
        <ul class="nav">
            <li>
                <router-link :to="{path:i.path}" active-class="active" v-for="(i,index) in nav_arr" :key="index"
                    @click.native="changeBgc(index)" exact>
                    <p>{{i.title}}</p>
                </router-link>
            </li>
        </ul>
    </div>
</template>
<script>
    import $ from 'jquery'
    export default {
        name: 'common-nav',
        data() {
            return {
                nav_arr: [
                    { title: '首页', path: '/' },
                    { title: '智能回收一代机', path: '/One' },
                    { title: '智能回收二代机', path: '/Two' },
                    { title: 'APP介绍', path: '/Introduce' },
                    { title: '合伙加盟', path: '/Join' },
                    { title: '新闻资讯', path: '/News' },
                    { title: '关于我们', path: '/About' }
                ],
                z_index: '0',
                timer: null
            }
        },
        created(){
            this.activeIndex = this.$route.path;
        },
        methods: {
            changeBgc(index) {
                this.z_index = index;
            },
        },
        mounted() {
            this.z_index = this.$route.query.item;
           
        },
        updated() {
            this.z_index = this.$route.query.item;
        },
        watch: {
            '$route'(to, from) {
                this.activeIndex = to.path;
                if (this.activeIndex == "/One") {
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                    // window.onload();
                } else if (this.activeIndex == "/Two") {
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                    // window.onload();
                } else if (this.activeIndex == "/Introduce") {
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                    // window.onload();
                } else if (this.activeIndex == "/Join") {
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                    // window.onload();
                } else if (this.activeIndex == "/News") {
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                    // window.onload();
                } else if (this.activeIndex == "/About") {
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                    // window.onload();
                } else if (this.activeIndex == "/") {
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                    // window.onload();
                }
                // window.onload();
            }
        }
    }
</script>
<style scoped>
    #common-nav {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-color: #0f0f0f;
    }

    .logo {
        width: 25%;
        height: 0.18rem;
        float: left;
    }

    .logo img {
        width: 0.29rem;
        height: 0.1rem;
        position: absolute;
        top: 0.04rem;
        left: 13%;
        vertical-align: middle;
    }

    .nav {
        width: 75%;
        float: left;
    }

    .nav li a {
        padding: 0 0.03rem;
        float: left;
        line-height: 0.18rem;
        font-size: 0.04rem;
        font-family: PingFang SC;
        font-weight: bold;
    }

    .nav li a {
        color: rgba(186, 186, 186, 1);
        float: left;
        margin-right: 10px;
    }

    .nav li .active {
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/views/common/nav.vue